module.exports = __webpack_public_path__ + "img/tamrazov.19ba4383.jpg";